import React, { useEffect, useState } from "react";
import { rateContest } from "../../../redux/contest/action";
import { useDispatch } from "react-redux";

export default function RateTOUSER({ posts, rating, values }) {
  const [loading, setLoading] = useState(false);
  const [giverating, setGiverating] = useState(rating || 0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (values) {
      setGiverating(values?.rating || 0);
    }
  }, [values]);

  const ratethisContest = (id) => {
    if (posts.is_mine == 1) {
      setGiverating(id);
      const data = {
        proposal_id: values.id,
        type: 1,
        rating: id,
        comment: "Super Work",
        post_id: posts?.id,
      };
      dispatch(rateContest(data, setLoading));
    }
    else {
      return null
    }

  };

  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`fa-solid fa-star ${star <= giverating ? "active" : ""}`}
          aria-hidden="true"
          onClick={() => ratethisContest(star)}
        ></i>
      ))}
    </div>
  );
}
